// cleanup_convert_to_typescript_file_SMBPYMT

export default {
  'smallBusinessPayments.approveNotEligible': 'Some payments are not eligible for approval',
  'smallBusinessPayments.deleteNotEligible': 'Some payments are not eligible for deletion',
  'smallBusinessPayments.eventWarning': '<%=event%>     Payment',
  'smallBusinessPayments.approveMessage':
    '<strong><%-count%></strong> <% count > 1 ? print("payments"): print("payment")%> will be <strong>approved</strong>.',
  'smallBusinessPayments.rejectMessage':
    '<strong><%-count%></strong> <% count > 1 ? print("payments"): print("payment")%> will be <strong>rejected</strong> and will not be processed.',
  'smallBusinessPayments.deleteMessage':
    '<strong><%-count%></strong> <% count > 1 ? print("payments"): print("payment")%> will be <strong>deleted</strong> and permanently removed.',
  'smallBusinessPayments.failApproveTitle': '<%= count %> Payment(s) cannot be approved',
  'smallBusinessPayments.failDeleteTitle': '<%= count %> Payment(s) cannot be deleted',
  'smallBusinessPayments.failRejectTitle': '<%= count %> Payment(s) cannot be rejected',
  'smallBusinessPayments.modifyTaxPayment': 'Modify Tax Payment',
  'smallBusinessPayments.noPaymentsToApprove': 'No payments to approve',
  'smallBusinessPayments.payeeName': 'Payee Name',
  'smallBusinessPayments.rejectNotEligible': 'Some payments are not eligible for rejection',
  'smallBusinessPayments.successApproveTitle': '<%= count %> Payment(s) have been  approved',
  'smallBusinessPayments.successDeleteTitle': '<%= count %> Payment(s) have been  deleted',
  'smallBusinessPayments.successMessage': 'Success! Payment has been submitted.',
  'smallBusinessPayments.successMessageNeedsApproval': 'Payment has been submitted for approval.',
  'smallBusinessPayments.successRejectTitle': '<%= count %> Payment(s) have been  rejected',
  'smallBusinessPayments.viewTaxPayment': 'View Tax Payment',
  'smallBusinessPayments.paymentToBeApproved': 'Payment will be approved.',
  'smallBusinessPayments.paymentToBeDeleted': 'Payment will be deleted.',
  'smallBusinessPayments.paymentToBeRejected':
    'Payment will be rejected and will not be processed.',
  'smallBusinessPayments.tabs.payments': 'Payments',
  'smallBusinessPayments.tabs.loanPayments': 'Loan Templates'
};
